import http from "@/plugins/http";

export const state = {
  activeWholesalers: [],
  wholesalersToUpdate: [],
  hasWholesalerToUpdate: false,
  search: {
    keyword: "",
    pageSize: 50,
    showCancelled: false
  }
};

export const getters = {
  activeWholesalers: state => {
    return state.activeWholesalers;
  },
  wholesalersToUpdate: state => {
    return state.wholesalersToUpdate;
  },
  hasWholesalerToUpdate: state => {
    return state.hasWholesalerToUpdate;
  }
};

export const mutations = {
  SET_WHOLESALERS(state, data) {
    state.activeWholesalers = data;
  },
  SET_WHOLESALERS_TO_UPDATE(state, data) {
    if (
      !state.wholesalersToUpdate.find(
        el => el.accountNumber == data.accountNumber
      )
    ) {
      state.wholesalersToUpdate.push(data);
    } else {
      let index = state.wholesalersToUpdate.findIndex(
        el => el.accountNumber == data.accountNumber
      );
      if (index >= 0) {
        state.wholesalersToUpdate[index] = data;
      }
    }
  },
  UPDATE_ACTIVEWHOLESALERS(state, data) {
    let index = state.activeWholesalers.findIndex(
      el => el.accountNumber == data.accountNumber
    );
    if (index >= 0) {
      state.activeWholesalers[index].cancelDate = data.cancelDate;
    }
  },
  REMOVE_WHOLESALERS_FROM_UPDATE_ARRAY(state, data) {
    let index = state.wholesalersToUpdate.findIndex(
      el => el.accountNumber == data.accountNumber
    );
    state.wholesalersToUpdate.splice(index, 1);
  },
  HAS_WHOLESALER_TO_UPDATE(state) {
    state.hasWholesalerToUpdate = state.wholesalersToUpdate.length > 0;
  },
  CLEAR_WHOLESALER_TO_UPDATE(state) {
    state.wholesalersToUpdate = [];
  }
};

export const actions = {
  async getActiveWholesalers({ dispatch, commit }, search) {
    try {
      let wholesalers = await http.post("visp/GetActiveWholesalers", search);
      if (wholesalers && wholesalers.data) {
        commit(`SET_WHOLESALERS`, wholesalers.data);
        Promise.resolve(wholesalers.data);
      }
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setWholesalersForUpdate({ commit }, data) {
    commit(`SET_WHOLESALERS_TO_UPDATE`, data);
    commit(`HAS_WHOLESALER_TO_UPDATE`);
  },
  removeWholesalerForUpdate({ commit }, data) {
    commit(`REMOVE_WHOLESALERS_FROM_UPDATE_ARRAY`, data);
    commit(`HAS_WHOLESALER_TO_UPDATE`);
  },
  async updateWholesalerDetails({ dispatch, commit }, data) {
    try {
      data.ubCustomerNumber = parseInt(data.ubCustomerNumber);

      let payload = JSON.stringify(data);
      let result = await http.post("visp/UpdateWholesalerDetails", payload);
      if (result < 1) {
        throw "Update error";
      }
      commit(`CLEAR_WHOLESALER_TO_UPDATE`);
      commit(`HAS_WHOLESALER_TO_UPDATE`);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async updateWholesalerCc({ dispatch }, payload) {
    try {
      let data = JSON.stringify(payload);
      let result = await http.post("wholesaler/UpdateCcWholesaler", data);
      
      dispatch(
        "httpResponse/setHttpResponse",
        { text: result.data, color: "success" },
        { root: true }
      );
      return Promise.resolve(result.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  updateActiveWholesalers({ commit }, data) {
    commit(`UPDATE_ACTIVEWHOLESALERS`, data);
  },
  async getTempCustomerDetails({ dispatch }, payload) {
    if (!payload) payload = 0;
    try {
      let result = await http.get(`visp/GetTempCustomerDetails/${payload}`);
      return Promise.resolve(result.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async createWholesalerLogin({ dispatch }, data) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let payload = JSON.stringify(data);
      let result = await http.post("wholesaler/CreateWholesalerLogin", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async readWholesalerLogins({ dispatch }, data) {
    try {
      let payload = JSON.stringify(data);
      let result = await http.post(`wholesaler/ReadWholesalerLogins`, payload);
      return Promise.resolve(result);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  async updateWholesalerLogin({ dispatch }, data) {
    try {
      let payload = JSON.stringify(data);
      let result = await http.patch(`wholesaler/UpdateWholesaleLogin`, payload);
      return Promise.resolve(result);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  async deleteWholesalerLogin({ dispatch }, data) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await http.delete(
        `wholesaler/DeleteWholesalerLogin/${data.id}/${data.accountNumber}`
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  }
};
